/**
 * Communication Facade
 *
 * Stable API surface for communication operations.
 * Aggregates actions for presentation layer consumption.
 * @agentic connections
 */

import type { MedplumClient } from "@medplum/core";
import type { Communication } from "@medplum/fhirtypes";
import {
  upsertCommunication,
  type UpsertCommunicationInput,
} from "@benchmark/core/actions";
import { CONFIG } from "@/app/config";

/**
 * Creates a Communication facade instance bound to a MedplumClient.
 * @agentic connections
 */
export function createCommunicationFacade(medplum: MedplumClient) {
  return {
    /**
     * Create or update a communication.
     * @agentic connections
     */
    upsert: (input: UpsertCommunicationInput): Promise<Communication> => {
      return upsertCommunication(medplum, {
        benchmarkOrganizationId: CONFIG.VITE_BENCHMARK_ORGANIZATION_ID,
        ...input,
      });
    },
  };
}
